import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'app/components';
import { Label } from '../../../event-list/components';
import { getImage, uploadImage } from '../../api';
import UploadModal from './uploadModal';
import UploadAadharModal from './uploadAadhar';
import { IMAGE_TAGS } from '../../../../constants/imageTags';
import { generateUniqueId } from '../../../../utils/commonUtils';
import { updateBusinessConfig } from '../../../event-list/api';
import { useSelector } from 'react-redux';

const formatAadharNumber = (value) => {
  const formattedValue = value?.replace(/(\d{4})(\d{4})(\d{4})/, '$1 $2 $3');
  return formattedValue;
};

const ViewProofsModal = ({
  isOpen,
  onClose,
  config,
  reducerPrefix,
  allowEdit,
}) => {
  const [proofImageUrl, setProofImageUrl] = useState('');
  const [proofImageBackUrl, setProofImageBackUrl] = useState('');
  const [secondaryProofImageUrl, setSecondaryProofImageUrl] = useState('');
  const [secondaryProofImageBackUrl, setSecondaryProofImageBackUrl] = useState('');
  const [isUploadOpen, setIsUploadOpen] = useState(false);

  const { userData } = useSelector((state) => state.app);

  useEffect(() => {
    if (config?.proof_image?.front) {
      getImage(config.proof_image.front).then((url) => {
        console.log(url)
        setProofImageUrl(url);
      });
    }
    if (config?.proof_image?.back) {
      getImage(config.proof_image.back).then((url) => { 
        setProofImageBackUrl(url);
      });
    }
  }, [config?.proof_image?.front, config?.proof_image?.back]);

  useEffect(() => {
    if (config?.secondary_proof_image?.front) {
      getImage(config.secondary_proof_image.front).then((url) => {
        setSecondaryProofImageUrl(url);
      });
    }
    if (config?.secondary_proof_image?.back) {
      getImage(config.secondary_proof_image.back).then((url) => {
        setSecondaryProofImageBackUrl(url);
      });
    }
  }, [config?.secondary_proof_image?.front, config?.secondary_proof_image?.back]);

  const onFileSubmit = (data) => {
    let uploadPromises = [];
    const businessConfigData = { ...config };

    if (config?.is_gst_registered) {
      const files = Array.isArray(data) ? data : data.files || [];
      if (files[0] instanceof File) {
        uploadPromises.push(
          uploadImage({
            image: files[0],
            tag: IMAGE_TAGS.GST,
            fileName: `${config?.user_id || generateUniqueId()}_${IMAGE_TAGS.GST}`,
            loaderId: 'org-proof-upload',
          })
        );
      }
    } else {
      const { files = [], panFileType, secondaryFileType } = data || {};
      const panFileCount = panFileType === 'pdf' ? 1 : 2;
      const secondaryFileCount = secondaryFileType === 'pdf' ? 1 : 2;



      const panFiles = files.slice(0, panFileCount);
      const secondaryFiles = files.slice(panFileCount);

      // Upload PAN files
      if (panFileCount === 1 && panFiles[0] instanceof File) {
        uploadPromises.push(
          uploadImage({
            image: panFiles[0],
            tag: IMAGE_TAGS.PAN_CARD,
            fileName: `${config?.user_id || generateUniqueId()}_${IMAGE_TAGS.PAN_CARD}`,
            loaderId: 'org-proof-upload',
          })
        );
      } else if (panFileCount === 2) {
        if (panFiles[0] instanceof File) {
          uploadPromises.push(
            uploadImage({
              image: panFiles[0],
              tag: IMAGE_TAGS.PAN_CARD,
              fileName: `${config?.user_id || generateUniqueId()}_${IMAGE_TAGS.PAN_CARD}`,
              loaderId: 'org-proof-upload',
            })
          );
        }
        if (panFiles[1] instanceof File) {
          uploadPromises.push(
            uploadImage({
              image: panFiles[1],
              tag: IMAGE_TAGS.PAN_CARD_BACK,
              fileName: `${config?.user_id || generateUniqueId()}_${IMAGE_TAGS.PAN_CARD_BACK}`,
              loaderId: 'org-proof-upload',
            })
          );
        }
      }

      // Upload secondary files
      if (secondaryFileCount === 1 && secondaryFiles[0] instanceof File) {
        let tag;
        switch (config?.secondary_proof_data) {
          case 'Aadhar Card':
            tag = IMAGE_TAGS.AADHAR;
            break;
          case 'Passport':
            tag = IMAGE_TAGS.PASSPORT;
            break;
          case 'Driving License':
            tag = IMAGE_TAGS.DRIVING_LICENSE;
            break;
          default:
            tag = IMAGE_TAGS.OTHERS;
        }
        uploadPromises.push(
          uploadImage({
            image: secondaryFiles[0],
            tag,
            fileName: `${config?.user_id || generateUniqueId()}_${tag}`,
            loaderId: 'org-proof-upload',
          })
        );
      } else if (secondaryFileCount === 2) {
        if (secondaryFiles[0] instanceof File) {
          let tag;
          switch (config?.secondary_proof_data) {
            case 'Aadhar Card':
              tag = IMAGE_TAGS.AADHAR;
              break;
            case 'Passport':
              tag = IMAGE_TAGS.PASSPORT;
              break;
            case 'Driving License':
              tag = IMAGE_TAGS.DRIVING_LICENSE;
              break;
            default:
              tag = IMAGE_TAGS.OTHERS;
          }
          uploadPromises.push(
            uploadImage({
              image: secondaryFiles[0],
              tag,
              fileName: `${config?.user_id || generateUniqueId()}_${tag}`,
              loaderId: 'org-proof-upload',
            })
          );
        }
        if (secondaryFiles[1] instanceof File) {
          let tag;
          switch (config?.secondary_proof_data) {
            case 'Aadhar Card':
              tag = IMAGE_TAGS.AADHAR_BACK;
              break;
            case 'Passport':
              tag = IMAGE_TAGS.PASSPORT_BACK;
              break;
            case 'Driving License':
              tag = IMAGE_TAGS.DRIVING_LICENSE_BACK;
              break;
            default:
              tag = IMAGE_TAGS.OTHERS;
          }
          uploadPromises.push(
            uploadImage({
              image: secondaryFiles[1],
              tag,
              fileName: `${config?.user_id || generateUniqueId()}_${tag}`,
              loaderId: 'org-proof-upload',
            })
          );
        }
      }
    }

    Promise.all(uploadPromises).then((resp) => {
      if (config?.is_gst_registered) {
        if (resp[0]) {
          businessConfigData.proof_image = {
            type: 'pdf', 
            front: resp[0]?.data?.data?.image_id,
            back: '',
          };
        }
      } else {
        const { files = [], panFileType, secondaryFileType } = data || {};
        const panFileCount = panFileType === 'pdf' ? 1 : 2;
        const secondaryFileCount = secondaryFileType === 'pdf' ? 1 : 2;

        let uploadIndex = 0;

        // Update proof_image for PAN
        if (panFileCount === 1 && files[0] instanceof File) {
          businessConfigData.proof_image = {
            type: 'pdf',
            front: resp[uploadIndex]?.data?.data?.image_id,
            back: '',
          };
          uploadIndex++;
        } else if (panFileCount === 2) {
          businessConfigData.proof_image = {
            type: 'png',
            front: files[0] instanceof File ? resp[uploadIndex]?.data?.data?.image_id : config?.proof_image?.front,
            back: files[1] instanceof File ? resp[uploadIndex + 1]?.data?.data?.image_id : config?.proof_image?.back,
          };
          uploadIndex += (files[0] instanceof File ? 1 : 0) + (files[1] instanceof File ? 1 : 0);
        }

        // Update secondary_proof_image
        if (secondaryFileCount === 1 && files[panFileCount] instanceof File) {
          businessConfigData.secondary_proof_image = {
            type: 'pdf',
            front: resp[uploadIndex]?.data?.data?.image_id,
            back: '',
          };
        } else if (secondaryFileCount === 2) {
          businessConfigData.secondary_proof_image = {
            type: 'png',
            front: files[panFileCount] instanceof File ? resp[uploadIndex]?.data?.data?.image_id : config?.secondary_proof_image?.front,
            back: files[panFileCount + 1] instanceof File ? resp[uploadIndex + 1]?.data?.data?.image_id : config?.secondary_proof_image?.back,
          };
        }
      }

      updateBusinessConfig(
        config?.business_config_id,
        { ...businessConfigData },
        reducerPrefix,
        () => {
          setIsUploadOpen(false);
        }
      );
    });
  };

  const renderFile = (url, type, altText = 'Proof Document') => {
    if (!url || !type) return null;

    if (type === 'png') {
      return <img src={url} alt={altText} className="w-fit h-fit" />;
    } else if (type === 'pdf') {
      return (
        <div>
          <a
            href={url}
            download={`${altText}.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            Download PDF
          </a>
        </div>
      );
    } else {
      return (
        <div>
          <a
            href={url}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            Download File
          </a>
        </div>
      );
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        hasClose={true}
        onClose={onClose}
        className="view-proofs-modal"
        title={config?.is_gst_registered ? 'Registered' : 'Not Registered'}
      >
        <div className="flex flex-col gap-4 items-center">
          {config?.is_gst_registered ? (
            <div className="flex flex-col gap-4">
              <Label title="GSTIN Number" content={config?.proof_data} />
              {config?.proof_image?.front && renderFile(proofImageUrl, config.proof_image.type, 'GST Certificate')}
            </div>
          ) : (
            <div className="flex flex-col gap-4">
              <Label title="PAN Number" content={config?.proof_data} />
              <div className="flex flex-col gap-4">
                {config?.proof_image?.type === 'pdf' && config?.proof_image?.front && renderFile(proofImageUrl, config.proof_image.type, 'PAN Document')}
                {config?.proof_image?.type === 'png' && config?.proof_image?.front && renderFile(proofImageUrl, config.proof_image.type, 'PAN Front')}
                {config?.proof_image?.type === 'png' && config?.proof_image?.back && renderFile(proofImageBackUrl, config.proof_image.type, 'PAN Back')}
              </div>
              <Label title="Secondary ID" content={config?.secondary_proof_data} />
              <div className="flex flex-col gap-4">
                {config?.secondary_proof_image?.type === 'pdf' && config?.secondary_proof_image?.front && renderFile(secondaryProofImageUrl, config.secondary_proof_image.type, `${config?.secondary_proof_data} Document`)}
                {config?.secondary_proof_image?.type === 'png' && config?.secondary_proof_image?.front && renderFile(secondaryProofImageUrl, config.secondary_proof_image.type, `${config?.secondary_proof_data} Front`)}
                {config?.secondary_proof_image?.type === 'png' && config?.secondary_proof_image?.back && renderFile(secondaryProofImageBackUrl, config.secondary_proof_image.type, `${config?.secondary_proof_data} Back`)}
              </div>
            </div>
          )}
          <Button onClick={() => setIsUploadOpen(true)}>Update Proofs</Button>
        </div>
      </Modal>
      {config?.is_gst_registered && isUploadOpen && (
        <UploadModal
          isOpen={config?.is_gst_registered && isUploadOpen}
          onClose={() => setIsUploadOpen(false)}
          uploadTitle="Upload your GST certificate"
          uploadFileName="Upload GST"
          reuploadText="Re-upload certificate"
          onSubmit={(file) => onFileSubmit([file])}
        />
      )}
      {!config?.is_gst_registered && isUploadOpen && (
        <UploadAadharModal
          isOpen={!config?.is_gst_registered && isUploadOpen}
          onClose={() => setIsUploadOpen(false)}
          uploadTitle="Upload your PAN card"
          uploadFileName1="Upload PAN"
          uploadFileName2="Upload PAN"
          reuploadText1="Re-upload PAN"
          reuploadText2="Re-upload PAN"
          secondaryProofType={config?.secondary_proof_data || 'Aadhar Card'}
          onSubmit={onFileSubmit}
        />
      )}
    </>
  );
};

export default ViewProofsModal;